const palette = [{ backgroundColor: "#F7F7F7" }, { backgroundColor: "#F5EFDD" }, { backgroundColor: "#2C2B28", color: "#EBEBEB" }];

export const getBlankImageStyle = (imageId: number) => {
    const paletteIndex = imageId % palette.length;
    return palette[paletteIndex];
}